/* eslint-disable indent */
import React from 'react';
import Link from 'next/link';

// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';
// import 'swiper/css/effect-fade';

// import { FreeMode, Navigation } from 'swiper/modules';
import useRouterHook from '@/hooks/useRouterHook.hook';
import { MotionComponent } from '../../../../atom/MotionComponent';
import TitleSection from '../../../../atom/Title/TitleSection';
import appRoutes from '../../../../../core/routes';
import GameProviderImage from '../../../../atom/GameProviderImage';
import useGameStore from '@/context/store/useGameStore.store';

const GameProviderProviderPageComponent2 = ({
	slideMode,
	showTitle = false
	// navigation = false,
	// centeredSlides = false,
	// loop = false
}) => {
	const { router } = useRouterHook();

	const { gameProviderData } = useGameStore();

	return (
		<React.Fragment>
			<MotionComponent slideMode={slideMode}>
				<div className="flex flex-col gap-6">
					{showTitle && <TitleSection title="Game Provider" />}
					<div className="flex gap-2 overflow-x-auto overflow-hidden scrollbar-none">
						{gameProviderData?.map((item, index) => (
							<div className="w-full h-full" key={index}>
								<div className="w-32">
									<Link
										href={{
											pathname: appRoutes.PROVIDER,
											query: {
												gp: item?.gpid,
												gpname: item?.gpname
											}
										}}>
										<a>
											<div
												className={`
												flex w-full h-full items-center justify-center text-center aspect-[2/1] rounded-lg cursor-pointer
												bg-gradient-to-b p-2
                        ${
													item?.gpid === router.query.gp
														? 'from-container-bg-accent2 to-container-bg-accent3 to-90%'
														: 'border border-container-color-primary'
												}
												`}>
												<GameProviderImage
													gameCategoryName={item?.gpid}
													gpName={item?.gpname}
													className={'w-full h-full'}
												/>
											</div>
										</a>
									</Link>
								</div>
							</div>
						))}
					</div>
					<p className="text-container-color-primary mb-section font-semibold">
						Game by {router.query.gpname}
					</p>
					{/* <div className="flex">
						<Swiper
						slidesPerView={'auto'}
						spaceBetween={12}
						loop={loop}
						freeMode={true}
						navigation={navigation}
							centeredSlides={centeredSlides}
							// autoplay={{
							// 	delay: 1,
							// 	disableOnInteraction: false
							// }}
							// speed={20000}
							modules={[FreeMode, Navigation]}
							className="mySwiper">
							{gameProviderData?.map((item, index) => (
								<SwiperSlide key={index} className="w-32">
									<Link
										href={{
											pathname: appRoutes.PROVIDER,
											query: {
												gp: item?.gpid,
												gpname: item?.gpname
											}
										}}>
										<a>
											<div
												className={`
												flex w-full h-full items-center justify-center text-center aspect-[2/1] rounded-lg cursor-pointer
												bg-gradient-to-b p-2
                        ${
													item?.gpid === router.query.gp
														? 'from-container-bg-accent2 to-container-bg-accent3 to-90%'
														: 'border border-container-color-primary'
												}
											`}>
												<GameProviderImage
													gameCategoryName={item?.gpid}
													gpName={item?.gpname}
													className={'w-full h-full'}
												/>
											</div>
										</a>
									</Link>
								</SwiperSlide>
							))}
						</Swiper>
					</div> */}
				</div>
			</MotionComponent>
		</React.Fragment>
	);
};

export default GameProviderProviderPageComponent2;
